import React, { useState } from "react";
import "./Faqs.css";

export default function Faqs() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: "Where is Arvind Plots Vadodara located?",
      a: "Arvind Plots Vadodara is located in Bil Village, near Ajwa Road, Vadodara — well connected to schools, Arvind Plots Vadodara is located in Bil Village, near Ajwa Road, Vadodara — well connected to schools, hospitals and highways.Arvind Plots Vadodara is located in Bil Village, near Ajwa Road, Vadodara — well connected to schools, Arvind Plots Vadodara is located in Bil Village, near Ajwa Road, Vadodara — well connected to schools, hospitals and highways.hospitals and highways.hospitals and highways.",
    },
    {
      q: "What is the Development status of Arvind SmartSpaces Plots Vadodara?",
      a: "The project is under rapid development with roads, electricity, drainage and amenities progressing on schedule.",
    },
    {
      q: "Who is the developer of this project?",
      a: "The project is developed by Arvind SmartSpaces — part of the multi-The project is developed by ArvindThe project is developed by Arvind SmartSpaces — part of the multi-billion Arvind GroupThe project is developed by Arvind SmartSpaces — part of the multi-billion Arvind GroupThe project is developed by Arvind SmartSpaces — part of the multi-billion Arvind Group SmartSpaces — part of the multi-billion Arvind Groupbillion Arvind Group.",
    },
    {
      q: "What plot sizes are available?",
      a: "Multiple plot sizes are available including 110 – 300 sq. yards suitable for residential villas and premium bungalows.",
    },
    {
      q: "What amenities are provided in Arvind Plots Vadodara?",
      a: "Amenities include clubhouse, cricket court, multipurpose court, yoga deck, landscaped garden, kids play area and more.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faqMn" id="faqs">
      <div className="maxW">
        <h2 className="faqHd">Faqs</h2>

        <div className="faqList">
          {faqs.map((f, i) => (
            <div key={i} className="faqItem " onClick={() => toggleFAQ(i)}>
              <div className="faqQ">
  <h3>{f.q}</h3>
  <strong>{openIndex === i ? "-" : "+"}</strong>
</div>


              {openIndex === i && (
                <p className="faqA">{f.a}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
